<template>
  <!--
  This is the top level component. It contains all of the components as
  children in some. In this case, it holds the links that route to other
  views. Below that, it has the router-view, which renders the component
  that is currently beeing routed. If the user is at home, for example,
  the router-view will render the home component.
-->
  <v-app>
    <div id="app">
      <router-view />
    </div>
  </v-app>
</template>
<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;700&display=swap');
// Load global styles
@import 'assets/scss/style.scss';

#app {
  font-family: 'Rubik', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
  font-family: 'Rubik', sans-serif;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.main-column {
  padding: 1em 1.5em !important;
}
</style>
